// extracted by mini-css-extract-plugin
module.exports = {"container":"Styles_container__p2kNM","checkmark":"Styles_checkmark__2S3-M"};